module.exports = __webpack_public_path__ + "home_s2_2.png?2876685f0029639d0eda7ba1307d2fc6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_s2_2.png
// module id = 5
// module chunks = 0